import script from "./Additional.vue?vue&type=script&lang=ts&setup=true"
export * from "./Additional.vue?vue&type=script&lang=ts&setup=true"

import "./Additional.vue?vue&type=style&index=0&id=fbd3d8ee&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbd3d8ee"]])

export default __exports__